export const sections = [
    {
        name: 'Design',
        slug: 'design',
        chapters: [
            {
                name: 'Design thinking',
                slug: 'design-thinking'
            },
            {
                name: 'Design components',
                slug: 'design-components'
            },
            {
                name: 'Customer experience',
                slug: 'customer-experience'
            }
        ]
    },
    {
        name: 'Design',
        slug: 'design',
        chapters: [
            {
                name: 'Design thinking',
                slug: 'design-thinking'
            },
            {
                name: 'Design components',
                slug: 'design-components'
            },
            {
                name: 'Customer experience',
                slug: 'customer-experience'
            }
        ]
    }
]


// WEBPACK FOOTER //
// ./client/data/sections.js